import React from "react";
import InfoBanner from '../InfoBanner'

/**
 * Componente para mostrar la new Data Driven Marketing (Contenido estático)
 *
 * @component
 *
 */

export const DataDrivenMarketing = (props) => {
  const [width, setWidth] = React.useState(window.innerWidth);
  const breakpoint = 620;

  React.useEffect(() => {
    const saveWidth = () => {
      setWidth(window.innerWidth);
    };

    /* Inside of a "useEffect" hook add an event listener that updates
        the "width" state variable when the window size changes */
    window.addEventListener("resize", saveWidth);

    /* passing an empty array as the dependencies of the effect will cause this
        effect to only run when the component mounts, and not each time it updates.
        We only want the listener to be added once */
    return () => window.removeEventListener("resize", saveWidth);
  }, []);

  const url = window.location.href;

  return (
    <section id="news-detail" className="text-center">
      <div className="col-md-8 col-md-offset-2 section-title">
        <h2>
          <span className="title">News</span>
        </h2>
      </div>
      <InfoBanner
        section={'Data Driven Marketing'}
        tittle={'Data Driven Marketing: personalizado, relevante y efectivo'}
        readingTime={'Tiempo de lectura 6 minutos'}
        keywords={['Data Driven Marketing', 'Análisis de Datos']}
        urlDesktop={'/img/news/DataDrivenMarketing/DataDrivenMarketing_img1.webp'}
        urlMobile={'/img/news/DataDrivenMarketing/DataDrivenMarketing_img1_mob.webp'}
      />
      <article className="container-fluid padding-fluid">
        <div className="row">
          <div className="col-md-12 visible-md visible-lg">
            <div className="col-md-1">&nbsp;</div>
          </div>
          <div className="col-md-12 visible-md visible-lg">
            <div className="col-md-1">&nbsp;</div>
          </div>
          <div className="col-md-12 visible-md visible-lg">
            <div className="col-md-1">&nbsp;</div>
          </div>
          <div className="col-md-12">
            <div className="col-md-1">&nbsp;</div>
          </div>
          <div className="col-md-12">
            <div className="col-md-8 col-md-offset-2 text-center">
              <p>
              En un mundo hiperconectado, el Data Driven Marketing se erige como la clave para una conexión eficiente con las audiencias. Este enfoque estratégico, basado en la recopilación y análisis de datos, garantiza decisiones informadas para la sostenibilidad del negocio.
                <br></br>
                <br></br>
                Centrado en el conocimiento profundo del cliente mediante el Big Data, este enfoque posibilita contenido altamente personalizado, mejorando la eficacia de las estrategias comerciales y, facilita la medición de la percepción de la marca, permitiendo decisiones fundamentadas sobre posicionamiento, precios y estrategias de comunicación.
                <br></br>
                <br></br>
                La segmentación y personalización, guiadas por la analítica de datos, hacen que los mensajes publicitarios sean más relevantes, aumentando la probabilidad de respuestas positivas y fortaleciendo la conexión emocional con la marca. Este enfoque impulsa el éxito de las campañas, combinando el poder de los datos con la necesaria dosis de creatividad en marketing.
                <br></br>
                <br></br>
              </p>
            </div>
          </div>
        </div>
      </article>
      <div
        className={width < breakpoint ? "" : "container-fluid padding-fluid"}
      >
        <div className={width < breakpoint ? "" : "row"}>
          <div className={width < breakpoint ? "" : "col-md-12"}>
            <div className={width < breakpoint ? "" : "col-md-8 col-md-offset-2 text-center"}>
              <div className="imgWithText">
                <img
                  style={{ width: "100%" }}
                  className="img-responsive"
                  alt="Data Driven Marketing"
                  src="/img/news/DataDrivenMarketing/DataDrivenMarketing_img2.webp"
                ></img>
                <h2 className="img3Text">El Data Driven Marketing, basado en la recopilación y análisis de datos, permite una conexión eficiente y personalizada con las audiencias.</h2>
              </div>
            </div>
          </div>
        </div>
      </div>
      <article className="container-fluid padding-fluid">
        <div className="row">
          <div className="col-md-12">
            <div className="col-md-8 col-md-offset-2 text-center">
              <p>
                <b>
                Pero ¿cómo podemos asegurarnos de que nuestras decisiones se basen en datos confiables y no en supuestos incorrectos?
                </b>
                <br></br>
                <br></br>
                La respuesta está en la rigurosidad en el análisis. La precisión en el análisis y la obtención de datos confiables y oportunos son imprescindibles para evitar decisiones erróneas que puedan afectar negativamente al negocio.
                <br></br>
                <br></br>
                Por otro lado, hay que tener claro que el análisis de datos no debe limitarse únicamente al entorno digital; es importante entender hábitos y comportamientos en diversos canales de contacto.
                <br></br>
                <br></br>
                Consultoras como Right Angle Media aportan perspectivas frescas y conocimientos de mejores prácticas, traduciéndose en estrategias innovadoras.
                <br></br>
                <br className="visible-md visible-lg"></br>
                <b>
                  El equilibrio entre los datos y la creatividad
                  </b>
              </p>
              <p>
                <br className="visible-md visible-lg"></br>
                El éxito de las campañas radica en el equilibrio entre creatividad y datos. Los datos proporcionan una base sólida para comprender las necesidades de la audiencia, mientras que la creatividad permite que las marcas destaquen y conecten con los clientes.
                <br></br>
                <br></br>
              </p>
            </div>
          </div>
        </div>
      </article>
      <div
        className={width < breakpoint ? "" : "container-fluid padding-fluid"}
      >
        <div className={width < breakpoint ? "" : "row"}>
          <div className={width < breakpoint ? "" : "col-md-12"}>
            <div className={width < breakpoint ? "" : "col-md-8 col-md-offset-2 text-center"}>
              <div className="imgWithText">
                <img
                  style={{ width: "100%" }}
                  alt="Data Driven Marketing"
                  className="img-responsive"
                  src="/img/news/DataDrivenMarketing/DataDrivenMarketing_img4.webp"
                ></img>
                <h2 className="img3Text">El manejo ético de la información y la colaboración interdisciplinaria es vital para garantizar estrategias coherentes y adaptativas.</h2>
              </div>
            </div>
          </div>
        </div>
      </div>
      <article className="container-fluid padding-fluid">
        <div className="row">
          <div className="col-md-12">
            <div className="col-md-8 col-md-offset-2 text-center">
              <p>
                <b>
                La ética en el manejo de los datos
                </b>
                <br></br>
                <br></br>
                En un mundo sin cookies, el manejo ético de los datos es ineludible. Valorar la seguridad de datos personalizados marca la diferencia entre el éxito y el fracaso comercial, garantizando una relación de confianza con el cliente.
              </p>
            </div>
          </div>
        </div>
      </article>
      <div className="container-fluid padding-fluid">
        <div className="row">
          <div className="col-md-12">
            <div className="col-md-8 col-md-offset-2 text-center">
            <p>
              <b>
              Colaboración Interdisciplinaria
              </b>
              </p>
              <p>
                El Data Driven Marketing no es exclusivo del área de marketing. La participación de todas las áreas de la empresa en el manejo de datos garantiza una aproximación integral a la estrategia empresarial. Esta colaboración interdisciplinaria asegura una experiencia coherente y enriquecedora para el cliente, resaltando la importancia de los datos en cada aspecto del negocio.
                <br></br>
                <br></br>
                En última instancia, el análisis de datos debe ofrecer insights relevantes que guíen la estrategia empresarial, permitiendo una adaptación rápida a los cambios del mercado y brindando certeza en la toma de decisiones en un futuro incierto.
              </p>
            </div>
            <div className="col-md-1 text-left"></div>
            <div
              className="col-md-3 text-left"
              style={{ display: width < breakpoint ? "block" : "none" }}
            >
              <p className="titleShare">COMPARTE</p>
              <div style={{ paddingBottom: "7px" }}>
                <a
                  className="share"
                  href={`https://www.facebook.com/sharer/sharer.php?u=${url}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Facebook
                </a>
              </div>
              <div style={{ paddingBottom: "7px" }}>
                <a
                  className="share"
                  href={`https://twitter.com/intent/tweet?url=${url}&text=Data Driven Marketing`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Twitter
                </a>
              </div>
              <div style={{ paddingBottom: "7px" }}>
                <a
                  className="share"
                  href={`https://www.linkedin.com/sharing/share-offsite/?url=${url}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  LinkedIn
                </a>
              </div>
              <div style={{ paddingBottom: "7px" }}>
                <a
                  className="share"
                  href={`mailto:?subject=Quiero compartir contigo esta noticia&body=Mira esta noticia ${url}`}
                >
                  Email
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
